import Authentication from "auth/Authentication";

var auth = new Authentication();

export default auth;
